import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col, Form, Container } from 'react-bootstrap';

import PageTitle from '../../common/PageTitle';
import ProgressingButton from '../../common/ProgressingButton'
import { setIsSaving, toggleShowAlert, SUCCESS_ALERT } from '../../store/actions/commonActions'

import APIClient from '../../common/APIClient';
const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

class SendNotification extends Component {

  constructor(props) {
    super(props);
    this.message = "";
  }

  sendNotif = async () => {
    this.props.setIsSaving(true);
    const message = this.message
    if (message) {
      const results = await client().post('notification/send',{ title: 'WAA ALERT', message, methods: ['inapp'], created_by: 1, channel: 'waa-alert' });
      if (results && results.status === 200) {
        this.props.toggleShowAlert(true, SUCCESS_ALERT, 'Push alert queued successfully. Please check the WAA App to confirm receipt')
      } else {
        this.props.toggleShowAlert(true, SUCCESS_ALERT, 'Push alert failed to send.')
      }
    }
    
    document.querySelector('.send-notification textarea').value = '';
    this.props.setIsSaving(false);
  }

  render() {
    return (
      <div>
        <Container className="waa-container">
            <PageTitle pageName="SEND NOTIFICATION"/>
            <hr />
            <Col>
                <Form className="waa-form send-notification">
                    <Form.Group controlId="message">
                      <Form.Label>Message</Form.Label>
                      <Form.Control 
                        as="textarea" 
                        rows={5} 
                        placeholder="Enter Message Content" 
                        onChange={(e) => {
                          this.message = e.target.value;
                        }}
                        />
                    </Form.Group>
                    <br/>
                    <ProgressingButton
                      className="sendNotifButton"
                      type="submit"
                      variant="primary"
                      onClick={this.sendNotif}
                      buttonValue="Send Notification" />
                </Form>
            </Col>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
  common: state.common,
})

const mapDispatchToProps = (dispatch) => {
  return {
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args)),
    setIsSaving: (...args) => dispatch(setIsSaving(...args)),
  }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SendNotification))